import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import CustomButton from 'components/shared/customButton';
import GridTable from 'components/shared/gridTable';
import NotificationCard from 'components/shared/notificationCard';
import SectionTitle from 'components/shared/sectionTitle';
import { isArray, isArrayEmpty } from 'utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  section: {
    minWidth: 0,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(2),
    marginBottom: spacing(2),
  },
  sectionDescription: {
    marginBottom: spacing(3),
    color: primary.bluish4,
  },
  table: {
    '& .actions-cell': {
      overflow: 'visible',
    },
    '& .actions-cell .row-cell-value': {
      overflow: 'visible',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      minHeight: 24,
    },
  },
  empty: {
    marginTop: spacing(2),
  },
}));

const SuccessionSettingsSection = ({
  translations,
  title,
  description = '',
  addLabel,
  noDataLabel,
  headers,
  headerActions,
  rows,
  onAdd,
}) => {
  const classes = useStyles();
  const hasRows = isArray(rows) && !isArrayEmpty(rows);

  return (
    <section className={classes.section}>
      <div className={classes.sectionHeader}>
        <SectionTitle title={title} variant="h5" />
        <CustomButton type="addDarkRoundedOutlined" onClick={onAdd}>
          {addLabel}
        </CustomButton>
      </div>
      {description ? (
        <Typography className={classes.sectionDescription} variant="body2">
          {description}
        </Typography>
      ) : null}
      {hasRows ? (
        <GridTable
          className={classes.table}
          translations={translations}
          headers={headers}
          headerActions={headerActions}
          rows={rows}
        />
      ) : null}
      <NotificationCard
        className={classes.empty}
        message={noDataLabel}
        shouldFade={!hasRows}
      />
    </section>
  );
};

SuccessionSettingsSection.propTypes = {
  translations: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  addLabel: PropTypes.string.isRequired,
  noDataLabel: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerActions: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default SuccessionSettingsSection;
